import { endpoints } from '../../../api/domains/endpoints';
import api from '../../../api';


// apiv3/widget/button/[widgetId]?apiKey=[apikey]&traceId=[traceId]

export async function getWidgetAPI ({ widgetId, apiKey, traceId, store}) {
    let url =  `${endpoints().buttonWidget}/${widgetId}?`
    url = `${url}apiKey=${apiKey}`;
    // url = `${url}traceId=${traceId}`;
    const res = await api.get(
        url,
        {},
        { traceId },
        store,
    );
    return res;
}

 